<template>
  <div class="main">
    <!--    <header class="header">-->
    <header :class="header_on?'header_on header':'header'"
      @mouseenter="header_on = true"
      @mouseleave="header_on = false">
      <div class="head">
        <div class="ym flex_lr">
          <div class="logo" @click="toUrl('/')">
            <img  style="cursor: pointer;display: inline-block" src="../assets/logo.png">
          </div>
          <ul class="head_nav" >
            <li v-for="(d,index) in nav_list"
                :class="nowpath==d.path?'havtive':''">
              <span v-if="!d.children" @click="headtoUrl(d.path)">{{ d.name }}</span>
              <span v-else >{{ d.name }}</span>
              <div class="head_d">
                <p v-for="(etem, index) in d.children" :class="nowpath2==etem.path?'oncolor':''" @click="headtoUrl(etem.path)">
                  {{etem.name}}
                </p>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </header>

<!--    el-fade-in-linear  fade mode="in-out"-->
    <!-- mode="in-out" 切换时，先出现元素，再隐藏元素 -->
    <!-- mode="out-in" 切换时，先隐藏元素，再出现元素 -->
    <transition name="fade-transform" mode="in-out">
        <router-view :key="$route.fullPath" > </router-view>
    </transition>

    <div class="end" v-if="end_show">
      <p class="ym end_title"> 关注我们</p>
      <div class="ym flex_lr_t">
        <div class="end_m">
          <div class="">
            <span @click="toUrl('/','')">首页</span>
          </div>
          <div class="">
            <span >集团简介</span>
            <span @click="toUrl('/company/1','')">公司简介</span>
            <span @click="toUrl('/company/2','')">公司文化</span>
            <span @click="toUrl('/company/3','')">党建活动</span>
            <span @click="toUrl('/company/4','')">集团架构</span>
            <span @click="toUrl('/company/5','')">核心成员</span>
          </div>
          <div>
            <span >业务板块</span>
            <span @click="toUrl('/creativePlant','')">创意设计</span>
            <span @click="toUrl('/exhibitPlant','')">展览展示</span>
            <span @click="toUrl('/sciencePlant','')">博雅科技</span>
            <span @click="toUrl('/artPlant','')">博雅艺品</span>
            <span @click="toUrl('/printingPlant','')">博雅彩印</span>
          </div>
          <div>
            <span >产业基地</span>
            <span @click="toUrl('/industrial','')">产业基地介绍</span>
          </div>
          <div>
            <span @click="toUrl('/news','')">新闻中心</span>
          </div>
          <div>
            <span >加入我们</span>
            <span @click="toUrl('/join/job','')">人才招聘</span>
            <span @click="toUrl('/join/address','')">公司位置信息</span>
          </div>
        </div>

        <div class="end_last">
          <img src="../assets/index/foot_logo.png">
          <p class="flex_r"><span></span>豫公网安备 41012202000304号 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">豫ICP备19035009号-2</a></p>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import {mapState,mapActions} from "vuex";
export default {
  inject:['reload'],
  data(){
    return{
      header_on:false,
      activeIndex: '0',
      tabList:[ ],
      menu_id: this.$route.params.id,
      newsList:[],
      end_show:true,

      nowpath:'/',
      nowpath2:'',
      headOn: 0,
      nav_list:[{
          name:"首页",
          path:"/",
        },{
          name:"简介",
          path:"/company",
          children:[{
              name:"公司简介",
              path:"/company/1",
            },{
              name:"公司文化",
              path:"/company/2",
            },{
              name:"党建活动",
              path:"/company/3",
            },{
              name:"集团架构",
              path:"/company/4",
            },{
              name:"核心成员",
              path:"/company/5",
            }]
         },{
          name:"业务方向",
          path:"/plant",
          children:[{
              name:"创意设计",
              path:"/creativePlant",
            },{
              name:"展览展示",
              path:"/exhibitPlant",
            },{
              name:"博雅科技",
              path:"/sciencePlant",
            },{
              name:"博雅艺品",
              path:"/artPlant",
            },{
              name:"博雅彩印",
              path:"/printingPlant",
          }]
          }, {
            name:"产业基地",
            path:"/industrial",
            children:[{
              name:"产业基地介绍",
              path:"/industrial",
            }]
          }, {
            name:"新闻中心",
            path:"/news",
          }, {
            name:"加入我们",
            path:"/join",
            children:[{
              name:"人才招聘",
              path:"/join/job",
            },{
              name:"公司位置信息",
              path:"/join/address",
            }]
          }],
    }
  },
  computed:{
    ...mapState(['bbanner',])
  },
  methods: {
    ...mapActions(['menu','indexPage']),

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push({
        path: key
      })
    },

    //跳转
    headtoUrl(url){
      this.header_on = false
      //this.reload()
      if(url.split('/')[1] == 'company'){
        this.nowpath = '/company'
      }else if(url.split('/')[1] == 'join'){
        this.nowpath = '/join'
      }{
        this.nowpath = url
      }
      this.$router.push({
        path: url
      })
    },

    toUrl(turl) {
      this.$router.push({
        path: turl
      })
    },
  },

  watch: { // watch的第二种写法
    $route: {
      handler (to, from){
        let url_one = this.$route.path.split('/')[1]
        if(url_one == 'company'){
          this.nowpath = '/company'
          this.end_show = true
        }else if(url_one == 'news_detail'){
          this.nowpath = '/news'
          this.end_show = true
        }else if(url_one == 'duty_detail'){
          this.nowpath = '/'
          this.end_show = true
        }else if(url_one == 'exhibitPlant_detail'){
          this.nowpath = '/plant'
          this.end_show = false
        }else if(url_one == 'exhibitPlant' || url_one == 'creativePlant' || url_one == 'sciencePlant' || url_one == 'artPlant' || url_one == 'printingPlant' ){
          this.nowpath = '/plant'
          this.end_show = true
        }else if(url_one == 'join'){
          this.nowpath = '/join'
          this.end_show = true
        }else{
          this.nowpath = this.$route.path
          this.end_show = true
        }

        //二级
        if(url_one == 'exhibitPlant_detail'){
          this.nowpath2 = '/exhibitPlant'
        }else{
          this.nowpath2 = this.$route.path
        }
      },
      deep: true // 深度观察监听
    }
  },

  created() {},

  mounted() {
    //判断路由
    if(this.$route.path){
      let url_one = this.$route.path.split('/')[1]
      if(url_one == 'company'){
        this.nowpath = '/company'
        this.end_show = true
      }else if(url_one == 'news_detail'){
        this.nowpath = '/news'
        this.end_show = true
      }else if(url_one == 'duty_detail'){
        this.nowpath = '/'
        this.end_show = true
      }else if(url_one == 'exhibitPlant_detail'){
        this.nowpath = '/plant'
        this.end_show = false
      }else if(url_one == 'exhibitPlant' || url_one == 'creativePlant' || url_one == 'sciencePlant' || url_one == 'artPlant' || url_one == 'printingPlant' ){
        this.nowpath = '/plant'
        this.end_show = true
      }else if(url_one == 'join'){
        this.nowpath = '/join'
        this.end_show = true
      }else{
        this.nowpath = this.$route.path
        this.end_show = true
      }

      //二级
      if(url_one == 'exhibitPlant_detail'){
        this.nowpath2 = '/exhibitPlant'
      }else{
        this.nowpath2 = this.$route.path
      }
    }

  }
}
</script>

<style scoped lang="less">

//.v-enter, .v-leave-to {
//  opacity: 0;
//}
//.v-enter-active, v-leave-active {
//  transition: opacity 1s;
//}

.fade-enter-active, .fade-leave-active{
  transition: all 0.8s;
}
.fade-enter{
  opacity: 1;
}
.fade-enter-to{
  opacity: 0.9;
}
.fade-leave{
  opacity: 0.9;
}
.fade-leave-to{
  display: none;
}


.main{
  width: 100%;
}
header{
  .logo{
    width: 80px;
    img{
      width: 100%;
      height: auto;
    }
  }
  .el-menu-demo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    color: #fff;
    padding: 0;
    overflow: hidden;
    border: none;
  }
}
.el-menu-item{
 // width: 100%;
  height: 70px;
  line-height: 70px;
  font-size: 15px;
  color: #333;
  border-bottom-color: transparent!important;
  transition: all 0.4s;
  box-sizing: border-box;
}
/deep/.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 70px;
  line-height: 70px;
}

.el-menu-item.is-active,.el-menu-item:hover{
  color: rgba(187, 0, 14, 0.8) !important;
}
/deep/.el-menu--horizontal>.el-submenu .el-submenu__title{
  color: #303133;
}
/deep/.el-submenu__icon-arrow{
 // display: none;
}


.header{
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 888;
  .head{
    width: 100%;
    background: #fff;
    z-index: 999;
  }
  .head_nav{
    //width: 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    padding: 0;
    border: none;
    background: #fff;
    li{
      width: 136px;
      font-size: 18px;
      font-weight: 500;
      color: #3E3A39;
      line-height: 70px;
      text-align: center;
      cursor: pointer;
      position: relative;
      span{
        line-height: 26px;
        display: inline-block;
        position: relative;
        &:after{
          content: '';
          width: 0;
          height: 5px;
          position: absolute;
          bottom: -5px;
          left: 50%;
          background: #BB0611;
          transition: all 0.4s;
        }
        &:hover{
          &:after{
            width: 100%;
            left: 0;
          }
        }
      }
    }
  }

  height: 70px;
  transition: all 0.4s;
  .head_nav{
    li{
      .head_d{
        transition: all 0.4s;
      //  visibility: hidden;
        height: 0;
        overflow: hidden;
        position: absolute;
        top: 100%;
        width: 100%;
        left: 0;
        z-index: 999;
        p{
          font-size: 16px;
          color: #333;
          line-height: 50px;
          cursor: pointer;
          &:hover{
            color: #BB0611;
          }
          &.oncolor{
            color: #BB0611;
          }
        }
      }
      &.havtive,&:hover{
        span{
          &:after{
            width: 100%;
            left: 0;
          }
        }
      }
    }
  }
  //&:hover,
  &.header_on{
    height: 330px;
    .head_nav{
      li{
        .head_d{
          height: 260px;
       //   visibility: visible;
        }
      }
    }
  }


  .head_div{
    padding: 0 0 26px;
    position: absolute;
    top: -280px;
    transition: all 0.6s;
    background: #fff;
    width: 100%;
    z-index: -1;
    .head_div_n{
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      li{
        width: 136px;
        div{
          p{
            font-size: 16px;
            color: #3E3A39;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            transition: all 0.4s;
            &:hover{
              color: #BB0611;
            }
          }
        }
      }
    }
    &.head_on{
      top: 70px;
    }
  }
}


.end {
  background-color: #BA1E29;
  padding: 40px 0 100px;
  .end_title{
    font-size: 18px;
    color: #FFFFFF;
    line-height: 30px;
    padding-bottom: 20px;
    margin-bottom: 15px;
    border-bottom: 1px solid #E0E0E0;
  }
  .end_m{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    &>div{
      width:140px;
      span{
        display: block;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 30px;
        cursor: pointer;
        &:first-child{
          font-size: 18px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .end_last{
    width: 125px;
    height: 45px;
    position: relative;
    img{
      width: 125px;
      height: 45px;
      display: inline-block;
      float: right;
    }
    p{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 30px;
      position: absolute;
      bottom: -110px;
      width: 500px;
      right: 0;
      text-align: right;
      span{
        display: inline-block;
        width: 24px;
        height: 25px;
        margin-right: 5px;
        margin-top: 2px;
        background: url("../assets/index/foot_img.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}



</style>